import React from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const AssessmentLineChart = ({ assessData, assessType, titleText = "Overall Assessment" }: any) => {
  const scale = assessType?.original?.question[0].fields.length - 1 || 10; // Default to 10 if scale is not provided

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: titleText,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: scale,
      },
      x: {
        ticks: {
          autoSkip: false, // Prevent automatic skipping of labels
          maxRotation: 30, // Rotate labels at a 45-degree angle
          minRotation: 30, // Also set the minimum rotation angle
        },
      },
    },
  };

  const chartData = {
    labels: assessData?.map((item: any) => item?.date),
    datasets: [
      {
        label: "Score",
        data: assessData?.map((item: any) => item?.score),
        borderColor: "rgb(218 , 126 , 57)",
        backgroundColor: "rgba(218 , 126 , 57, 0.5)",
      },
    ],
  };

  return (
    <div>
      <Line options={options} data={chartData} />
    </div>
  );
};
